import React from "react";
import Agents from "../../components/pages/agents/Agents";

export default function AgentsPage() {
  return <Agents />;
}
